import React from 'react'
import { Link } from "react-router-dom";


const Gallery = () => {
    return (
        <>


            <section className="breadcrumb-wrapper fix bg-cover" style={{ backgroundImage: 'url(https://res.cloudinary.com/dnquglkeh/image/upload/v1771511829/SBS06987-Pano_2_xhjkdi.jpg)' }}>
                <div className="container">
                    <div className="row">
                        <div className="page-heading">
                            <h2 className="wow fadeInUp" data-wow-delay=".3s">Our Gallery</h2>
                            <ul className="breadcrumb-list wow fadeInUp" data-wow-delay=".5s">
                                <li>
                                    <Link to="/">Home</Link>
                                </li>
                                <li><i className="fa-solid fa-chevron-right" /></li>
                                <li>Our Gallery</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
            <section className="courses-section section-padding fix">
                <div className="container">
                    <div className="courses-wrapper mt-0">
                        <div className="row justify-content-center">
                            <div className="col-xl-5">
                                <ul className="nav" role="tablist">

                                    <li className="nav-item wow fadeInUp" data-wow-delay=".6s">
                                        <a href="#ambition" data-bs-toggle="tab" className="nav-link" aria-selected="false" role="tab" tabIndex={-1}>
                                            Events
                                        </a>
                                    </li>
                                    <li className="nav-item style-2 wow fadeInUp" data-wow-delay=".2s">
                                        <a href="#technical" data-bs-toggle="tab" className="nav-link active" aria-selected="false" role="tab" tabIndex={-1}>
                                            Show All
                                        </a>
                                    </li>
                                    <li className="nav-item wow fadeInUp" data-wow-delay=".4s">
                                        <a href="#work" data-bs-toggle="tab" className="nav-link" aria-selected="true" role="tab">
                                            Sports
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="tab-content">
                            <div id="technical" className="tab-pane fade active show" role="tabpanel">
                                <div className="row">

                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/39.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/40.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/19.jpg" alt="img" />

                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/18.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/16.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/47.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/48.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/49.jpg" alt="img" />

                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/23.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/43.jpg" alt="img" />

                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/34.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/44.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/38.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/33.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/42.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/3.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/58.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/2.jpg" alt="img" />

                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/1.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/22.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/5.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/4.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/6.jpg" alt="img" />

                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/7.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/9.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/10.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/11.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/12.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/13.jpg" alt="img" />

                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/14.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/15.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/17.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/24.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/25.jpg" alt="img" />

                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/26.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/27.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/28.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/29.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/30.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/31.jpg" alt="img" />

                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/32.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/35.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/36.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/37.jpg" alt="img" />

                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/41.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/20.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/21.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/22.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/50.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/51.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/52.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/53.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/54.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/56.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                </div>





                            </div>
                            <div id="work" className="tab-pane fade" role="tabpanel">
                                <div className="row">
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/9.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/10.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/11.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/12.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/37.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/51.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/52.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/56.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/54.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="ambition" className="tab-pane fade" role="tabpanel">
                                <div className="row">
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/3.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/1.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/2.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/5.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/29.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/58.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/17.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="featured-courses-item-2">
                                            <div className="courses-image">
                                                <img src="assets/img/svp/gallery/30.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </section>


        </>
    )
}

export default Gallery